import { css } from 'styled-components';
import { CardSectionHeading } from '../../../../../components/Header/DoubleHeader/CardSection/styles';
import {
  LanguageText,
  StyledLanguageToggle,
} from '../../../../../components/Header/DoubleHeader/LanguageToggle/styles';
import {
  MegaMenuContainer,
  Logo as MegaMenuLogo,
  StyledGridItem as MegaMenuStyledGridItem,
  MegamenuZIndex,
} from '../../../../../components/Header/DoubleHeader/Megamenu/styles';
import {
  IconWithMargin,
  TertiaryButtonWithIcon,
} from '../../../../../components/Header/DoubleHeader/TopMenu/TertiaryNavItem/styles';
import {
  HeaderInner,
  RightAlignedGridItem,
  CtaContainer as TopMenuCtaContainer,
  Logo as TopMenuLogo,
} from '../../../../../components/Header/DoubleHeader/TopMenu/styles';
import { MegamenuPlaceholder } from '../../../../../components/Header/DoubleHeader/styles';
import {
  LinkWrapper,
  Section,
  SectionHeading,
  SectionLinks,
} from '../../../../../components/Header/NavDesktop/PrimaryNavDesktop/Menus/styles';
import {
  CtaContainer,
  Menu,
  NavItem,
  NavItemArrow,
} from '../../../../../components/Header/NavDesktop/PrimaryNavDesktop/styles';
import {
  navItemSelectedBar,
  NavItemText,
} from '../../../../../components/Header/NavDesktop/styles';
import { SVGWrapper } from '../../../../../components/Icon/styles';
import { StyledLink } from '../../../../../components/Link/styles';
import helpersColors from '../../../../../helpers/colors';
import mediaQuery from '../../../../../helpers/mediaQuery';
import spacing from '../../../../../helpers/spacing';
import { colors, themeSpecificColors } from '../../../colors';
import { headerBoxShadowStyle } from '../../../helpers/commonStyles';

const logoHeight = spacing(9.55);
const headerInnerPadding = spacing(2);
const focusBoxShadowSize = '4px';

export default css`
  ${MegamenuPlaceholder} {
    height: calc(${logoHeight} + 2 * ${headerInnerPadding});
    background-color: ${colors.neutral08};
  }

  ${MegaMenuContainer} {
    position: fixed;
    padding: ${spacing(2)} 0 ${spacing(2)} ${spacing(1)};
    background-color: ${colors.neutral08};
    border-bottom: none;
    ${headerBoxShadowStyle};

    ${mediaQuery.tabletLandscape`
      position: relative;
      padding: 0;
    `}
  }

  ${MegaMenuLogo} {
    img {
      height: ${logoHeight};
    }
  }

  ${MegaMenuStyledGridItem} {
    height: ${logoHeight};

    ${mediaQuery.tabletLandscape`
      height: ${spacing(7)};
    `}
  }

  ${HeaderInner} {
    height: calc(${logoHeight} + 2 * ${headerInnerPadding});
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: ${MegamenuZIndex + 1};

    ${mediaQuery.tabletLandscape`
      padding: ${headerInnerPadding} 0;
    `}
  }

  ${RightAlignedGridItem} {
    align-items: flex-start;
  }

  ${TopMenuLogo} {
    img {
      ${mediaQuery.tabletLandscape`
        height: ${logoHeight};
        border: none; 
        border-left: solid 2px transparent;
      `}
    }
  }

  ${TopMenuCtaContainer} {
    align-items: flex-start;
  }

  ${NavItem} {
    ${navItemSelectedBar(helpersColors.navigationHighlight, spacing(7))}

    &:hover {
      background-color: ${colors.core02};

      ${NavItemText} {
        color: ${colors.neutral08};
        font-weight: 500;
      }

      ${NavItemArrow} {
        svg {
          fill: ${colors.neutral08};
        }
      }
    }

    &:focus-visible {
      border-radius: 0;
      box-shadow: 0 0 0 2px ${colors.core01},
        0 0 0 ${focusBoxShadowSize} ${themeSpecificColors.core01_60};
    }
  }

  ${StyledLanguageToggle} {
    padding: ${spacing(1.25)} ${spacing(2)};
  }

  ${NavItemText} {
    color: ${colors.neutral01};
    font-size: 1rem;
    line-height: 1.5rem;
    font-weight: 500;
    padding-right: ${spacing(1)};
  }

  ${NavItemArrow} {
    svg {
      fill: ${colors.neutral03};
    }
  }

  ${LinkWrapper} {
    margin: ${spacing(2)} 0;
  }

  ${TertiaryButtonWithIcon} {
    flex-direction: row-reverse;
    font-size: 1rem;
    line-height: 1.25rem;
    font-weight: 500;
    padding: ${spacing(2.5)} ${spacing(1)};
    border-radius: 0;

    :hover {
      text-decoration: none;
      text-shadow: none;
    }

    :active {
      color: ${colors.neutral08};

      ${IconWithMargin} {
        ${SVGWrapper} {
          svg {
            fill: ${colors.neutral08};
          }
        }

        background-color: ${themeSpecificColors.core02_80};
      }
    }
  }

  ${IconWithMargin} {
    height: ${spacing(5)};
    width: ${spacing(5)};
    border-radius: 50%;
    background-color: ${themeSpecificColors.core03_10};
    margin: 0 ${spacing(1)} 0 0;

    /* Centre the icon */
    display: flex;
    justify-content: center;
    align-items: center;

    transition: all 0.3s ease-out;

    ${SVGWrapper} {
      height: ${spacing(2.5)};
      width: ${spacing(2.5)};

      svg {
        fill: ${colors.core01};
      }
    }
  }

  ${Menu} {
    background-color: ${colors.core02};
  }

  && {
    ${Section} {
      &:last-child {
        padding-left: 0;
        border-left: none;
      }
    }
  }

  ${SectionHeading} {
    color: ${themeSpecificColors.core04_40};
    font-size: 1rem;
    line-height: 1.5rem;
    font-weight: 500;
    margin-bottom: ${spacing(2)};
  }

  ${SectionLinks} {
    color: ${colors.neutral08};

    ${StyledLink} {
      font-size: 1rem;
      line-height: 1.5rem;
      font-weight: 400;

      :hover,
      :focus-visible {
        color: ${colors.neutral08};
      }

      :focus-visible :after {
        border-radius: 0;
      }
    }
  }

  ${CardSectionHeading} {
    font-weight: 500;
    line-height: 2rem;
  }

  ${CtaContainer} {
    display: none;
  }

  ${LanguageText} {
    font-size: 1rem;
    line-height: 1.5rem;
    font-weight: 500;
  }
`;
